<template>
  <k-page class="page-slides">
    <the-slides />
  </k-page>
</template>

<script>
/**
 * Component: page-slides - Страница слайдов
*
* @version 1.0.0
*/


// Components
import TheSlides from '@/components/TheSlides.vue';
import KPage from '@/components/KPage.vue';


export default {
  name: 'page-slides',

  components: {
    KPage,
    TheSlides,
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.page-slides {
  $this: &;
}
</style>
